module.exports = __webpack_public_path__ + "static/media/slider02_tc.eafd0a5b.png";